import { render, staticRenderFns } from "./_detail.vue?vue&type=template&id=7a97bc63&scoped=true&"
import script from "./_detail.vue?vue&type=script&lang=js&"
export * from "./_detail.vue?vue&type=script&lang=js&"
import style0 from "./_detail.vue?vue&type=style&index=0&id=7a97bc63&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a97bc63",
  null
  
)

export default component.exports